import type { AxiosInstance } from 'axios';

export interface NudgeItem {
  id: number;
  type: string;
  icon: string;
  text: string;
  action: { label: string; href: string };
  createdAt: string;
}

export interface NudgeData {
  id: string;
  icon: string;
  text: string;
  action: { label: string; href: string };
}

export type NudgesService = ReturnType<typeof createNudgesService>;

function mapNudge(item: NudgeItem): NudgeData {
  return {
    id: String(item.id),
    icon: item.icon,
    text: item.text,
    action: item.action,
  };
}

export function createNudgesService(client: AxiosInstance) {
  return {
    async getNudges(): Promise<NudgeData[]> {
      const { data } = await client.get<{ data: NudgeItem[] }>('/purchasers/nudges');
      return data.data.map(mapNudge);
    },

    async dismissNudge(nudgeId: string): Promise<void> {
      await client.post(`/purchasers/nudges/${nudgeId}/dismiss`);
    },
  };
}
